var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPcvLineIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.619,
    height: 16.29,
    viewBox: "0 0 28.619 16.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_190881",
    "data-name": "Group 190881",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 2.759,
    cy: 2.759,
    rx: 2.759,
    ry: 2.759,
    transform: "translate(4.518 9.773)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 1.235,
    cy: 1.235,
    rx: 1.235,
    ry: 1.235,
    transform: "translate(6.042 11.297)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 2.759,
    cy: 2.759,
    rx: 2.759,
    ry: 2.759,
    transform: "translate(18.308 9.773)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 1.235,
    cy: 1.235,
    rx: 1.235,
    ry: 1.235,
    transform: "translate(19.831 11.297)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1303",
    "data-name": "Line 1303",
    x2: 8.272,
    transform: "translate(10.035 12.531)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173289",
    "data-name": "Path 173289",
    d: "M69.514,33.453h2.377a1.415,1.415,0,0,0,1.414-1.414v-.524a.445.445,0,0,0-.445-.445H68.14",
    transform: "translate(-45.686 -20.922)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173290",
    "data-name": "Path 173290",
    d: "M5.018,33.453h-3.1A1.415,1.415,0,0,1,.5,32.039v-.289a.681.681,0,0,1,.681-.681H6.392",
    transform: "translate(-0.5 -20.922)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173291",
    "data-name": "Path 173291",
    d: "M52.38,16.54h8a.97.97,0,0,1,.969.969v3.854",
    transform: "translate(-35.158 -11.215)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1304",
    "data-name": "Line 1304",
    x1: 11.506,
    transform: "translate(1.178 5.325)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173292",
    "data-name": "Path 173292",
    d: "M4.05,10.648V2.488A1.988,1.988,0,0,1,6.038.5H22.122a1.046,1.046,0,0,1,1.046,1.046V5.825",
    transform: "translate(-2.872 -0.5)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1305",
    "data-name": "Line 1305",
    x1: 19.118,
    transform: "translate(1.178 1.892)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1306",
    "data-name": "Line 1306",
    y1: 3.432,
    transform: "translate(4.966 1.892)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1307",
    "data-name": "Line 1307",
    y1: 3.432,
    transform: "translate(8.86 1.892)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1308",
    "data-name": "Line 1308",
    y1: 10.639,
    transform: "translate(17.222 1.892)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1309",
    "data-name": "Line 1309",
    y1: 10.639,
    transform: "translate(12.684 1.892)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1310",
    "data-name": "Line 1310",
    x2: 2.46,
    transform: "translate(17.222 10.148)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1311",
    "data-name": "Line 1311",
    x2: 4.02,
    transform: "translate(8.664 10.148)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173293",
    "data-name": "Path 173293",
    d: "M75.288,21.7H73.867a.616.616,0,0,0-.617.617v.91a.616.616,0,0,0,.617.617h1.421",
    transform: "translate(-49.1 -14.662)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcvLineIcon);
export default __webpack_public_path__ + "static/media/PCV-LineIcon.35b1e57ab7bfc0fb005b957ed55fdd71.svg";
export { ForwardRef as ReactComponent };